import store from '@/store';
import router from '@/router';
import routes from './route';
import layout from '@/modules/settings/store/layout';
import {userProfile} from '@/modules/settings/store/user-profile';
import {routes as storeRoutes} from '@/modules/settings/store/routes';
import {customer} from '@/modules/settings/store/customer';

const MODULE_NAME = 'settings';
const TRANSLATION_PREFIX = 'settings/';

export default class SettingsModule {

  static uninstall() {
    store.unregisterModule(MODULE_NAME);
  }

  static install() {

    store.registerModule(MODULE_NAME, {namespaced: true});
    store.registerModule([MODULE_NAME, 'layout'], layout);
    store.registerModule([MODULE_NAME, 'userProfile'], userProfile);
    store.registerModule([MODULE_NAME, 'routes'], storeRoutes);
    store.registerModule([MODULE_NAME, 'customer'], customer);

    let enMap = new Map();

    enMap.set(TRANSLATION_PREFIX + 'profile', () => import("@/modules/settings/translations/en/profile.json"));
    enMap.set(TRANSLATION_PREFIX + 'navbar', () => import("@/modules/settings/translations/en/navbar.json"));
    enMap.set(TRANSLATION_PREFIX + 'settings', () => import("@/modules/settings/translations/en/settings.json"));
    enMap.set(TRANSLATION_PREFIX + 'customer', () => import("@/modules/settings/translations/en/customer.json"));

    let deMap = new Map();
    deMap.set(TRANSLATION_PREFIX + 'profile', () => import("@/modules/settings/translations/de/profile.json"));
    deMap.set(TRANSLATION_PREFIX + 'navbar', () => import("@/modules/settings/translations/de/navbar.json"));
    deMap.set(TRANSLATION_PREFIX + 'settings', () => import("@/modules/settings/translations/de/settings.json"));
    deMap.set(TRANSLATION_PREFIX + 'customer', () => import("@/modules/settings/translations/de/customer.json"));

    let translationMap = new Map();
    translationMap.set('en', enMap);
    translationMap.set('de', deMap);

    store.commit('translation/updateImportMap', translationMap);
    this.installNameSpace();
  }

  static installNameSpace() {
    //namespace that is used for all or most components
    let globalNamespace = ['settings/profile', 'settings/navbar', 'dialog', 'snackbar'];

    let namespaces = globalNamespace;
    if (store.state.translation.namespaces) {
      namespaces = namespaces.concat(store.state.translation.namespaces);
    }

    store.commit("translation/updateNamespaces", namespaces);
    store.commit("translation/loadNamespaces");
  }

  static installRoutes() {
    routes.forEach(function(route){
      router.addRoute(route);
    });
  }
}
